export default "__VITE_ASSET__BW65SduT__"